import memoize from 'lodash/memoize';

export const isSafari = memoize(() => {
  if (typeof navigator === 'undefined') {
    return false;
  }

  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
});
